import React from 'react';
import { isEmpty } from 'lodash';
import Carousel, { Modal, ModalGateway } from 'react-images';

import View from './View';
import Header from '@components/snippets/FileViewer/Header';
import NavigationPrev from '@components/snippets/FileViewer/NavigationPrev';
import NavigationNext from '@components/snippets/FileViewer/NavigationNext';

/**
 * @return {null}
 */
function FileViewer({
  visible,
  files,
  onClose,
  onDelete,
  currentIndex,
  ...rest
}) {
  return visible && !isEmpty(files) ? (
    <ModalGateway {...rest}>
      <Modal className="test" onClose={onClose} onDelete={onDelete}>
        <Carousel
          onClose={onClose}
          onDelete={onDelete}
          currentIndex={currentIndex}
          views={files}
          frameProps={{ autoSize: 'height' }}
          components={{ View, Header, NavigationNext, NavigationPrev }}
          styles={{
            view: (base) => ({
              ...base,
              height: 'calc(100vh - 54px)',
              '& > img': {
                maxHeight: 'calc(100vh - 94px)',
              },
            }),
          }}
        />
      </Modal>
    </ModalGateway>
  ) : null;
}

FileViewer.propTypes = {};

export default FileViewer;
